@if (isContentLoading()) {
<mat-progress-bar class=" rounded layout-shop__progress-bar" mode="indeterminate" value="accent"></mat-progress-bar>
}

<div class="layout-shop" [class.layout--sidebar-closed]="!isSidebarOpen()">
  <!-- Sidebar -->
  @if(isContentLoaded()){
  <div class="layout-shop__sidebar animated fadeIn" [class.sidebar--closed]="!isSidebarOpen()"
    [class.height-layout]="!hasGlobalMessages()" [class.height-layout-global-message]="hasGlobalMessages()">
    <div class="overlay" (click)="toggleSidebar()"></div>
    <app-sidebar (outIsMenuReady)="scrollIntoView()"></app-sidebar>
    <div class="toggle-sidebar" (click)="toggleSidebar()" (mouseenter)="toggleCollapseBarHover(true)"
      (mouseleave)="toggleCollapseBarHover(false)">

      <i [ngClass]="{
          'text-primary': true,
          'fas': true,
          'fw-bolder': true,
          'toggle-sidebar__icon': true,
          'fa-angles-right': !isSidebarOpen(),
          'fa-angles-left': isSidebarOpen(),
        }"></i>
    </div>
  </div>
  }
  <!-- Main content -->
  <div class="layout-shop__main" [class.padding-top-whitout-filter-tags]="!showFiltersTags() && !filters().size"
    [class.height-layout-shop__main]="!hasGlobalMessages()"
    [class.height-layout-shop__main-global-message]="hasGlobalMessages()" (scroll)="onScroll($event)" #layoutShopMain
    id="layoutShopMain">

    @if (showFiltersTags() || filters().size) {
    <div class="filters">

      <!-- Filter tags -->
      @if (showFiltersTags()) {
      <section class="filter-tags" id="filterTags">
        @for (item of sidebarService.filterTags(); track item.listId + '-' + item.sublistId) {
        <div class="filter-tags__tag">
          <span>
            {{item.name}}
          </span>
          <i class="material-symbols-outlined" (click)="sidebarService.removeTag(item)">
            close
          </i>
        </div>
        }
        @if (showMoreItemTags()) {
        <span class="material-symbols-outlined more">
          more_horiz
        </span>
        }
      </section>
      }

      <!-- Filter text -->
      @if (filters().size) {
      <ul class="filter-chips-container">
        @for (filter of filters().entries(); track $index) {
        <li>
          <mat-chip-row (removed)="removeChipFilter(filter[0])" [editable]="true" class="bg-secondary bg-opacity-25">
            <div class="d-flex gap-1">
              <b>{{filter[1].type}}:</b> <span class="fst-italic text-decoration-underline">{{filter[1].value}}</span>
            </div>
            <button matChipRemove [attr.aria-label]="'remove ' + filter[0]">
              <span class="material-symbols-outlined">
                close
              </span>
            </button>
          </mat-chip-row>
        </li>
        }
      </ul>
      }

    </div>
    }

    @if(!marketStatus().isOpen) {
    <div class="closed-market-container animated fadeIn">
      <div class="alert" role="alert">
        <span class="material-symbols-outlined mat-icon-fill icon">
          calendar_today
        </span>
        <div class="text-container">

          <p class="header">{{closedMarket().title}}</p>
          <p class="legend">{{closedMarket().legend}}</p>
        </div>
      </div>
    </div>
    }

    <div class="container-fluid" id="scroll-to-top-ref">

      @if (!isContentLoading() && isContentLoaded()) {
      @if (!productsSignal().length) {
      <app-empty-message [message]="emptyMessage" class="mt-4"></app-empty-message>
      }
      }

      <div class="row product-card-grid" [class.padding-at-bottom-sm]="productsSignal().length <= 3">
        @defer (on viewport) {
        @if (productsSignal()) {

        @for (product of productsSignal(); track (product.id + '-' + $index)) {

        <!-- CATEGORY -->
        <!-- @if (product.categoryInView && product.categoryInView.show) {
        <div #subcategory [attr.shop-data-anchor-link]="product.categoryAnchorLink"
          [attr.category-id]="product.category.id" [attr.sub-category-id]="-1">
          @if (product.categoryInView.banner) {
          <a [href]="product.categoryInView.url ? product.categoryInView.url : 'javascrip:void(0)'"
            [attr.category-id]="product.category.id" [id]="product.category.id">
            <img [src]="product.categoryInView.banner" alt="Banner of category: {{product.category.name}}"
              class="img-fluid animated fadeInDown w-100 mb-4">
          </a>
          } @else if(displayCategoryName()) {
          <h3 class="category fw-bold" [attr.category-id]="product.category.id" [id]="product.category.id">
            {{ product.category.name }}
          </h3>
          }
        </div>
        } -->

        <!-- SUB-CATEGORY -->
        @if (product.subCategoryInView && product.subCategoryInView.show) {
        <div #subcategory [attr.shop-data-anchor-link]="product.subcategoryAnchorLink"
          [attr.category-id]="product.category.id" [attr.sub-category-id]="product.subcategory.id">
        </div>
        @if (product.subCategoryInView.banner) {
        @let bannerUrl = product.subCategoryInView.url;
        @let bannerId = product.category.id + '-' + product.subcategory.id;
        <a (click)="onBannerClicked(bannerUrl, bannerId)" href="javascript:void(0)" [id]="bannerId"
          [attr.category-id]="product.category.id" [attr.sub-category-id]="product.subcategory.id" #subcategory>
          <img [src]="product.subCategoryInView.banner" alt="Banner of subcategory: {{product.subcategory.name}}"
            class="img-fluid animated fadeInDown w-100 mb-4">
        </a>
        } @else {
        <h3 class="category" [id]="product.category.id + '-' + product.subcategory.id"
          [attr.category-id]="product.category.id" [attr.sub-category-id]="product.subcategory.id" #subcategory>
          {{ product.subcategory.name }}
        </h3>
        }
        }

        <!-- SUB-CATEGORY-SON -->
        @if (product.subCategorySonInView && product.subCategorySonInView.show) {
        <div #subcategorySon [attr.shop-data-anchor-link]="product.subcategorySonAnchorLink"
          [attr.category-id]="product.category.id" [attr.sub-category-id]="product.subcategory.id"
          [attr.sub-category-son-id]="product.subcategorySon.id">
        </div>
        @if (product.subCategorySonInView.banner) {
        @let bannerUrl = product.subCategorySonInView.url;
        @let bannerId = product.category.id + '-' + product.subcategory.id + '-' + product.subcategorySon.id;
        <a (click)="onBannerClicked(bannerUrl, bannerId)" href="javascript:void(0)" [id]="bannerId"
          [attr.category-id]="product.category.id" [attr.sub-category-id]="product.subcategory.id"
          [attr.sub-category-son-id]="product.subcategorySon.id" #subcategorySon>
          <img [src]="product.subCategorySonInView.banner" alt="Banner of subcategory: {{product.subcategorySon.name}}"
            class="img-fluid animated fadeInDown w-100 mb-4">
        </a>
        } @else {
        <h3 class="category" [id]="product.category.id + '-' + product.subcategory.id + '-' + product.subcategorySon.id"
          [attr.category-id]="product.category.id" [attr.sub-category-id]="product.subcategory.id"
          [attr.sub-category-son-id]="product.subcategorySon.id" #subcategorySon>
          {{ product.subcategorySon.name }}
        </h3>
        }
        }

        @defer (on viewport; prefetch on immediate) {
        <div class="col-xxl-3 col-lg-4 col-6" id="{{product.id}}" (mouseenter)="onProductCardHover(product.id)">
          <div class="product-card-grid__item">
            @let productDetails = this.productDetails().get(product.id);
            <app-product-card-v2 [cardResume]="{ product, settings: {}, productDetails:  productDetails}"
              (onComponentReady)="onProductCardReady(product.id)" [isFromShop]="!!productDetails">
            </app-product-card-v2>
          </div>
        </div>

        } @placeholder {
        <div class="col-xxl-3 col-lg-4 col-6" id="{{product.id}}">
          <section class="d-flex flex-column flex-grow-1">
            <div class="product-card__head"></div>
            <div class="product-card__img-wrap">
              <a>
                <div class="product-card__img"></div>
              </a>
            </div>
            <div style="height: 150px;"></div>
          </section>
        </div>
        }
        }
        }
        }
        @placeholder {
        <div class="px-3">
          <mat-progress-bar class="rounded layout-shop__progress-bar" mode="indeterminate"
            value="accent"></mat-progress-bar>
        </div>
        }
      </div>
    </div>
  </div>
</div>